import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { useTheme } from '../../theme/useTheme';

interface StatsCardProps {
    title: string;
    value: string | number;
    assignedStudents?: string | number;
    icon?: IconDefinition;
    iconColor?: string;
    valueColor?: string;
    className?: string;
    synced_count?: any
    style?: React.CSSProperties;
    onClick?: any
}

export default function StatsCard({
    title,
    value,
    assignedStudents,
    icon,
    synced_count,
    iconColor = "primary",
    valueColor = "primary",
    className = "",
    style = {},
    onClick
}: StatsCardProps) {
    const { colors } = useTheme();

    return (
        <Card
            className={`h-76 ${className}`}
            style={{
                backgroundColor: colors.background.primary,
                border: `1px solid ${colors.border.secondary}`,
                boxShadow: colors.shadow,
                borderRadius: '12px',
                ...style
            }}
            onClick={onClick}
        >
            <Card.Body>
                <div className="d-flex align-items-center justify-content-between">
                    <div className="">
                        <h3 style={{ color: colors.primary.main, fontWeight: 'bold', marginBottom: '0.25rem', fontSize: '1.1rem' }}>
                            {typeof value === 'number' ? value.toLocaleString() : value}
                            {assignedStudents &&
                                <span style={{ color: colors.text.secondary, fontSize: '.9rem' }}>
                                    /{typeof assignedStudents === 'number' ? assignedStudents.toLocaleString() : assignedStudents}
                                </span>
                            }
                        </h3>
                        <span style={{ color: colors.text.muted, fontSize: '0.7rem' }}>{title}</span> <br />
                        <span style={{ color: colors.text.muted, fontSize: '0.7rem' }}>{synced_count}</span> <br/>
                    </div>
                    {icon && (
                        <div className="align-self-center ms-3">
                            <FontAwesomeIcon
                                icon={icon}
                                style={{ fontSize: '2rem', color: colors.primary.main }}
                            />
                        </div>
                    )}
                </div>
            </Card.Body>
        </Card>
    );
}

export type { StatsCardProps };
